import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 375px) {
    max-width: 375px;
  }

  @media screen and (min-width: 768px) {
    max-width: 768px;
    padding: 0 32px;
  }

  @media screen and (min-width: 1280px) {
    max-width: 1280px;
    padding: 0 100px;
  }
`;

